import { FaRegCalendarCheck } from "react-icons/fa";

import Title from "./common/Title";
import List from "./common/List";
import { formatDate } from "../utils/format";
import { ReservationInfoResponse } from "../types/reservation";
import { useTranslation } from "react-i18next";

interface Props {
  reservationInfo: ReservationInfoResponse;
}

interface StatusType {
  [key: string]: { value: string; color: string };
}

const ReservationInfo = ({ reservationInfo }: Props) => {
  const { t } = useTranslation();
  const { reservation_status, reservation_no, check_in_date, check_out_date, nights } = reservationInfo;

  const status: StatusType = {
    RR: {
      value: "Due In",
      color: "bg-gray-300",
    },
    CI: {
      value: "Check In",
      color: "bg-green-300",
    },
  };

  return (
    <section>
      <Title icon={<FaRegCalendarCheck />} title={t("reservation_info")} />
      <List className="mt-2">
        <List.ColumnWrapper>
          <List.ColumnItem
            label={t("reservation_status")}
            value={status[reservation_status].value}
            valueClassName={`w-24 px-2 rounded-lg bg-gray-200 text-center text-white font-medium text-white ${status[reservation_status].color}`}
          />
          <List.ColumnItem label={t("reservation_no")} value={reservation_no} />
        </List.ColumnWrapper>
        <List.ColumnWrapper>
          <List.ColumnItem label={t("checkin")} value={formatDate(check_in_date)} />
          <List.ColumnItem label={t("checkout")} value={formatDate(check_out_date)} />
        </List.ColumnWrapper>
        <List.Item label={t("nights")} value={nights} />
      </List>
    </section>
  );
};

export default ReservationInfo;
